import getApi, { getApiUrl } from './api';
import { IntercomsService } from '../intercoms/intercoms-service';
import { FirmwaresService } from '../firmware/firmware-service';
import { AuditLogService } from '../auditLog/audit-log-service';

let _apiClient: IApiClient | null = null;


export interface IApiClient {
  intercoms: IntercomsService;
  firmware: FirmwaresService;
  audit: AuditLogService;
}
interface IProps {
  isPoolingMode?: boolean | undefined;
}
export const apiClient = (props?: IProps) => {
  if (!_apiClient || props?.isPoolingMode) {
    const apiUrl = getApiUrl() ?? '';
    const api = getApi({isPoolingMode: props?.isPoolingMode});

    _apiClient = {
      intercoms: new IntercomsService(apiUrl, api),
      firmware: new FirmwaresService(apiUrl, api),
      audit: new AuditLogService(apiUrl, api),
    };
  }

  return _apiClient;
}
